<template>
  <div
    class="t-alert rounded-lg flex items-center px-2 py-4"
    :class="classesColor[kind]"
    role="alert"
  >
    <div class="flex-none px-2" :class="classesSvgColor[kind]">
      <UIcon :name="icons[kind]" class="w-7 h-7" aria-hidden="true" />
    </div>
    <div class="flex-1 py-2 px-2">
      <div class="t-alert--title mb-0" :class="classesTitleColor[kind]">
        <slot name="title" />
      </div>

      <div class="t-alert--text mb-0" :class="classesColor[kind]">
        <slot name="text" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { type TAlertKind } from './constants/types'
import {
  classesColor,
  classesTitleColor,
  classesSvgColor,
  icons,
} from './constants/constants'

interface TText_Props {
  kind?: TAlertKind
}

withDefaults(defineProps<TText_Props>(), {
  kind: 'green',
})
</script>
